import * as React from "react";
import FlatButton from "material-ui/FlatButton";
import { FormatMessage } from "react-globalize";
import { format } from "lib/globalize-util";
import { Link } from "react-router";
import { rawTheme as theme } from "styles/theme";
import _ from "lodash";
import { DATATEST } from "constants/integration";

interface IProps {
    action: string;
    catalog: any;
    entry?: any;
    onChangeCatalog?: () => void;
}

export class Message extends React.PureComponent<IProps, any> {
    handleClick = () => {
        const { entry, onChangeCatalog } = this.props;

        if (entry) {
            entry.destroy();
        }

        if (onChangeCatalog) {
            onChangeCatalog();
        }
    };

    render() {
        const { action, catalog, onChangeCatalog } = this.props;
        const message = {
            path: action === "bulk" ? "Products Added to" : "Added to catalog",
            vars: { catalog: catalog.title },
            link: catalog._link,
        };
        const buttons = [];
        if (action === "item") {
            buttons.push({ label: format("Undo"), onClick: this.handleClick });
            if (onChangeCatalog) {
                buttons.push({ label: format("Change"), onClick: this.handleClick });
            }
        }
        return <SnackbarMessage message={message} buttons={buttons} />;
    }
}

interface IMessageProps {
    message: {
        path: string;
        vars?: object;
        link?: any;
    };
    buttons?: Array<{ label: string; onClick: () => void }>;
}

export class SnackbarMessage extends React.PureComponent<IMessageProps, {}> {
    private styles = {
        color: theme.palette.primary1Color,
        margin: "4px",
        backgroundColor: "transparent",
    };

    render() {
        const { message, buttons } = this.props;
        return (
            <React.Fragment>
                <FormatMessage
                    path={message.path}
                    variables={message.vars}
                    elements={{ link: message.link && <Link to={message.link} /> }}
                />
                {!!buttons.length &&
                    _.map(buttons, ({ label, onClick }, i) => (
                        <FlatButton
                            data-test={DATATEST.MANAGE_CONNECTIONS.SEND_LINESHEET}
                            key={i}
                            style={this.styles}
                            label={label}
                            onClick={onClick}
                        />
                    ))}
            </React.Fragment>
        );
    }
}
